import React, { memo } from "react";
import { FormHelperText, Grid, TextField } from "@mui/material";
import { Field, FieldProps, FormikProps, useFormikContext } from "formik";
import CommonFields from "./PosCommonFields";
import ArrayInput from "../../../common/arrayInput/ArrayInput";
import Autocomplete from "@mui/material/Autocomplete";
import { Data as PosSoftwareData } from "../../../store/possoftware/types";
import { Data } from "../../../store/pos/types";

import { isNil } from "ramda";
import { ApplicationState } from "../../../store";
import { useSelector } from "react-redux";
import pageStyles from "../../pageStyles";

const formatSoftwareVersions = (items: string[]) =>
  items.reduceRight((i, x) => `(${x}) ${i}`, "");

const NexoFields = () => {
  const formikProps = useFormikContext();
  const { errors, values } = formikProps as FormikProps<Data>;
  const classes = pageStyles();

  const softwareDisplayText = (option: PosSoftwareData) =>
    `${option.attributes.ProviderIdentification} - ${
      option.attributes.ApplicationName
    } - Versions: ${formatSoftwareVersions(option.attributes.SoftwareVersion)}`;

  const posSoftwareState = useSelector(
    (state: ApplicationState) => state.posSoftware
  );

  const posSoftware = posSoftwareState?.data?.data || ([] as PosSoftwareData[]);

  values.attributes.POSSoftwarePresentation = posSoftware.filter(
    (option) => option.id === values.attributes.POSSoftware
  )[0];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Field name="attributes.POIID">
          {(props: FieldProps) => {
            const {
              form: { setFieldValue },
            } = props;
            return (
              <ArrayInput
                label="POS is allowed to pair with the following POI Devices"
                value={values.attributes.POIID || []}
                onChange={(data: string[]) => {
                  setFieldValue("attributes.POIID", data);
                }}
              />
            );
          }}
        </Field>
        {errors?.attributes?.POIID && (
          <FormHelperText error>{errors?.attributes?.POIID}</FormHelperText>
        )}
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={5}>
            <Field name="attributes.POSSoftwarePresentation">
              {(props: FieldProps) => {
                const {
                  form: { setFieldValue },
                } = props;
                return (
                  <Autocomplete
                    id="posSoftware-autocomplete"
                    options={posSoftware}
                    value={values.attributes.POSSoftwarePresentation}
                    onChange={(
                      _event: React.ChangeEvent<{}>,
                      value: PosSoftwareData | null
                    ) => {
                      if (!isNil(value)) {
                        setFieldValue(
                          "attributes.POSSoftwarePresentation",
                          value
                        );
                        setFieldValue("attributes.POSSoftware", value.id, true);
                      }
                    }}
                    getOptionLabel={(option) => softwareDisplayText(option)}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>{softwareDisplayText(option)}</li>
                    )}
                    renderInput={(params) => {
                      return (
                        <TextField
                          {...params}
                          label="POS Software*"
                          variant="outlined"
                        />
                      );
                    }}
                  />
                );
              }}
            </Field>
            {errors?.attributes?.POSSoftware && (
              <FormHelperText error>
                {errors?.attributes?.POSSoftware}
              </FormHelperText>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <hr className={classes.devide} />
      </Grid>
      <CommonFields />
    </Grid>
  );
};

export default memo(NexoFields);
